module.exports = __webpack_public_path__ + "media/entities/5001-0dfd4984.png";